import { BlockPageHelper, PreLoadHelper } from "../Helpers/helpers";
import { DocumentPreview } from "../PDF/DocumentPreview";

export class ISiteMobileDocumentFileViewerPage {
    constructor() {  }
    public Init() {
        $(".card-isite-header").hide();
        $("#footer-bar").hide();
        $(".page-title").hide();

        const dp: DocumentPreview = new DocumentPreview("#previewPlaceholder");
       
        const action: string = $("#previewPlaceholder").data("action");
        const url: string = $("#previewPlaceholder").data("url");
        $("#backButton").click(() => {
            BlockPageHelper.block();
            history.back();
        });

        $("document").ready(() => {
            if (action.startsWith("image")) {
                dp.openImage(url);
            }
            else if (action === "application/pdf") {
                dp.openPdf(url, 3)
            }
        });
    }    
};